export default{
	url:{
		"2":"/userManager/userBaseInfo",
		"3":"/userManager/userPersonalInfo",
		"4":"/userManager/userCompanyInfo",
		"6":"/power/roleManager",
		"7":"/power/accountManager",
		"30":"/contentManager/recommendedActivities",
		"31":"/contentManager/serviceCenter",
		"9":"/contentManager/homeBanner",
		"10":"/contentManager/hotWordSearch",
		"22":"/workManager/workInfoAll",
		"23":"/workManager/materialBank",
		"24":"/workManager/labels",
		"25":"/workManager/commentManager",
		"26":"/activityManager/activityEmploy",
		"27":"/activityManager/activityClass",
		"28":"/activityManager/activityworks",
		"29":"/otherInformation/solicitationTemplate",
		"32":"/employmentManager/employmentorder",
		"34":"/otherInformation/embodyRecord",
		"35":"/otherInformation/presetReason",
		"36":"/otherInformation/feedback",
		"37":"/otherInformation/reportInfo",
		"38":"/noticeManager/newsRelease",
		"39":"/noticeManager/noticetemplate",
		"40":"/contentManager/listAd",
		"41":"/contentManager/holdAll",
		"50":"/userManager/blackList",

		"261":"/workManager/workInfo",
		"277":"/contribution-library/photographic-works",
		"282":"/contribution-library/ordinary-works",
		// "68":"/art/item0", // 用户信息表
		// "69":"/art/item1?tabs=0", // 空中逛展
		// "70":"/art/item2", // 遇鉴艺术
		"71":"/art/item3", // 专题列表
		"72":"/art/item4", // 文章管理
		// "73":"/art/item5", // 玩趣古今
		// "74":"/art/item6", // 趣读
		"75":"/art/item-channel",//渠道管理
		"76":"/art/fastappfeedback-list",//渠道管理
		"79":"/art/kyy-tools",//
		"79":"/art/kyy-tools",//
		"83":"/art/novel_review",//
		"84":"/art/activity_lottery",//
		"85":"/art/mood_post",//
		"86":"/art/pao_pao",//
		"87":"/art/lion_pen",
		"88":"/art/astrological_love",
		
		
		"200495":"/projectManagement/projectList",
		"200605":"/projectManagement/projectLongList",
		"200496":"/projectManagement/projectclass",
		"200497":"/projectManagement/settlement",
		"200498":"/projectManagement/Profit",
		"51":"/contentManager/projectrecommende",
		"200478":"/contentManager/workconfig",
		"200473":"/userManager/userInfo",
		"200808":"/contribution-library",
		"200726":"/contentManager/personal-center",
		"200712":"/contentManager/points-mall",

		"288":"/userLog",
		"289":"/adminLog",
		"290":"/keyList",
		
	},
}